<template>
  <div class="container">
      <div class="joinus-banner" >
          <div class="joinus-write">
            <p class="p1">加入我们</p>
            <p class="p2">JOIN US</p>
          </div>
      </div>
      
      <div class="joinus-content">
        <div class="joinus-width">
          <div class="join-main01">
            <p class="p1">业务合作品牌</p>
            <p class="p2">BUSINESS COOPERATION</p>
            <p class="p3">作为行业创新实践的先行者，我们致力于以优质产品与服务回应用户期待。欢迎志同道合的品牌、厂商加入，共同为客户和宠物带来更多美好，为家庭生活增添温暖。</p>
          </div>
          <div class="join-main02">
             <img :src="joinusimg" alt=""/>
              <!-- <ul>
                  <li v-for="(td,index) in tds" :key="index">
                        <img v-lazy="td.img" />
                  </li>
              </ul> -->
          </div>
          <div class="join-main03">
            <div class="join-images">
              <img :src="pic2" alt=""/>
              <!-- <img v-for="(item,index) in items" :key="index" v-lazy="item.img" />   -->
            </div>
          </div>
          <div class="join-main04">
            <div class="p1">合作联系方式</div>
            <div class="p2">CONTACT US</div>
            <div class="ioin-main-image">
              <img src="../assets/joinus/ic_mali.png" />
            </div>
            <p class="p3">如果您有合作意向，请联系我们。</p>
            <p class="p4">MollyBox魔力猫盒：<span class="font-medium">BDmollybox@xolo.vip</span></p>
            <p class="p5">六脚兽：<span class="font-medium">liujiaoshou@xolo.vip</span></p>
            <!-- <p class="p5 p6">联系电话：<span class="font-medium">021-33680890</span></p> -->
          </div>
        </div>
      </div>
      <div class="joinus-footer">
        <div class="joinus-footer01">
          <p class="p1">加入我们</p>
          <p class="p2">JOIN US</p>
        </div>
        <div class="joinus-footer02">
          <div class="joinus-width">
             <div class="joinus-footer-left">
               <img :src="pic1" alt=""/>
             </div>
             <div class="joinus-footer-right">
               <div class="joinus-footer-write">
                  <p class="p1">如果您也是<span>养猫养狗</span>用户，如果您也<span>喜爱小动物</span>，如果你也想工作中被<span>众多猫咪包围</span>，欢迎您来与<span>上海索洛</span>共同成长与发展，欢迎查看招聘职位。</p>
                  <a target="_blank" href="https://www.lagou.com/gongsi/508927.html"><button>查看招聘职位</button></a>
               </div>
             </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'JoinUs',
  data(){
    return{
      pic2:require('../assets/joinus/pic_2.png'),
      pic1:require('../assets/joinus/pic_1.jpg'),
      joinusimg:require('../assets/joinus/join_logo2x.png'),
    }
  },
  props: {
  }
}
</script>

<style scoped lang="less">
  .joinus-banner{
      width: 100%;
      height: 400px;
      background: url('../assets/joinus/banner.jpg') center center no-repeat;
      background-size:cover ;
      // min-height: 100vh;
      text-align: center;
      .joinus-write{
        padding-top: 98px;
        .p1{
          font-size: 40px;
          letter-spacing: 6px;
          color: #000000;
          padding: 116px 0 27px;
          font-weight: 600;
        }  
        .p2{
          font-size: 20px;
          letter-spacing: 5px;
          color: #000000;
        }  
      }
  }
  .joinus-content{
    width: 100%;
    .joinus-width{
      .width;
      .join-main01{
        text-align: center;
        .p1{
          font-size: 32px;
          letter-spacing: 5px;
          color: #000000;
          padding: 122px 0 22px;
          font-weight: 600;
        }
        .p2{
          font-size: 16px;
          letter-spacing: 4px;
          color: #666666;
        }
        .p3{
          width: 1120px;
          padding:69px 0 60px; 
          font-size: 16px;
          letter-spacing: 2px;
          color: #333333;
          line-height: 29px
        }
      }
      .join-main02{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        min-height: 484px;
        img{
          display: block;
        }
        ul{
            overflow: hidden;
            border-top:1px solid #f0f0f0;
            border-left: 1px solid #f0f0f0; 
            li{float: left;
                border-right:1px solid #f0f0f0;
                border-bottom: 1px solid #f0f0f0; 
                width: 182px;
                height: 102px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                img{
                    display: block
                }
            }
        }
      }
      .join-main03{
        padding: 49px 0 120px;
        .join-images{
          min-height: 276px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img{
            display: block;
          }
        }
      }
      .join-main04{
        width: 1100px;
        // height: 484px;
        padding-bottom: 100px;
        background-color: #f7f6f4;
        text-align: center;
        .p1{
          font-size: 32px;
          letter-spacing: 5px;
          color: #333333;
          padding: 99px 0 19px;
          font-weight: 600;
        }
        .p2{
          font-size: 16px;
          letter-spacing: 4px;
          color: #666666;
        }
        .ioin-main-image{
          text-align: center;
          padding: 40px 0 39px;
          img{
            width: 66px;
            height: 48px;
          }
        }
        .p3{
          font-size: 20px;
          letter-spacing: 3px;
          color: #666666;
        }
        .p4{
          font-size: 20px;
          letter-spacing: 3px;
          padding: 17px 0;
          color: #666666;
          
        }
        .p5{
          font-size: 20px;
          letter-spacing: 3px;
          color: #666666;
        }
        p{
          span{
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 3px;
            color: #333333;
          }
        }
      }
    }
  }
  .joinus-footer{
    width: 100%;
    .joinus-footer01{
      height: 432px;
      text-align: center;
      .p1{
        font-size: 32px;
        letter-spacing: 5px;
        color: #000000;
        padding: 119px 0 19px;
        font-weight: 600;
      }
      .p2{
        font-size: 16px;
        letter-spacing: 4px;
        color: #666666;
      }
    }
    .joinus-footer02{
      background-color: #f7f6f4;
	    opacity: 0.94;
      width: 100%;
      height: 471px;
      .joinus-width{
        width: 1100px;
        margin: 0 auto;
        .joinus-footer-left{
          float: left;
          margin-top:-158px; 
          width: 514px;
          height: 574px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img{
            display: block
          }
        }
        .joinus-footer-right{
          float: left;
          width: 531px;
          margin-left: 55px;
          .joinus-footer-write{
            text-align: justify;
            .p1{
              font-size: 18px;
              letter-spacing: 3px;
              color: #666666;
              padding: 80px 0 69px;
              line-height: 32px;
              span{
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 3px;
                color: #000000;
              }
            }
            button{
              width: 158px;
              height: 54px;
              background-color: #f7f7f5;
              border: solid 2px #333333;
              font-size: 16px;
              letter-spacing: 0px;
              color: #333333;
              cursor: pointer;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
    //共用
    .width{width: 1100px;margin: 0 auto;} 
</style>
